angular.module('manufacturing')
    .component('manufacturingOrderBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<'
        },
        templateUrl: 'app/manufacturing/_btn-options.html',
        controller: function ($rootScope, ManufacturingOrderService, Principal, FilesSimpleUploadService, FilesLibrary) {
            this.ManufacturingOrderService = ManufacturingOrderService
            this.FilesLibrary = FilesLibrary
            this.FilesSimpleUploadService = FilesSimpleUploadService

            this.fileResourceName = 'MANUFACTURING-ORDER'

            this.$onChanges = () => {
                this.canDelete = Principal.hasAnyAuthority(["ROLE_ADMIN"]);
                this.canManageFiles = true;
            }

            this.attachFile = () => FilesSimpleUploadService.open({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast('manufacturing-order.updated'));
            this.attachLibraryFile = () => FilesLibrary.openAndBind({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast('manufacturing-order.updated'));
        }
    })
